var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SingleDashboard',{attrs:{"ActiveSections":_vm.ComputedTabSections,"System":_vm.System,"SystemEntities":_vm.SystemEntities,"AllFields":[],"MyActivitiesArray":_vm.MyActivitiesArray,"UnreadNotifications":_vm.UnreadNotifications}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }